<!--
 * @Author: your name
 * @Date: 2022-06-22 09
-->
<template>
  <div>
    <div class="maintain"><img src="~@/assets/icon/home/feedback_banner.jpg" alt=""></div>
    <second-title 
      letter="M"
      enTitle="aintenance guide"
      current_add="保养指南"
      add_one="首页"
      add_tow="无极服务"
      add_three="保养指南"
    >
    </second-title>
    <!-- 列表 -->
    <div class="mainlist">
      <!-- 条件筛选 -->
      <div class="model_screen">
        <van-dropdown-menu active-color="#FDB819">
          <van-dropdown-item v-model="seriesVal" :options="seriesList" @change="seriesConfirm"/>
          <van-dropdown-item v-model="MCTypeVal" :options="MCTypeList" @change="MCTypeConfirm"/>
          <!-- <van-dropdown-item v-model="manualsVal"  :options="manualsList" @change="manualsConfirm"/> -->
        </van-dropdown-menu>
        <div class="user_handbook" @click="manualsConfirm">用户手册下载</div>
      </div>
      <!-- 数据列表 -->
      <div class="main_row">
        <div class="main_details" v-for="(item,index) in imgLIst" :key="index" @click="showVideo(item)">
          <div class="main_img animate__animated animate__zoomIn"><img :src="item.preview" alt=""></div>
          <div class="main_name animate__animated animate__zoomIn">{{item.title}}</div>
        </div>
        <!-- 无数据 -->
        <van-empty v-if="imgLIst.length<=0" description="暂无数据" />
      </div>
    </div>
    <!-- 查看更多 -->
    <div class="view_more" @click="moreClick" v-if="!moreLoading && noMore">
      <div>查看更多</div>
      <van-icon name="arrow-down" class="ckgd" />
    </div>
    <div class="view_more" @click="moreClick" v-else-if="moreLoading">
      <div>加载中...</div>
    </div>
    <div class="view_more" @click="moreClick" v-else-if="noMore">
      <div></div>
    </div>
    <!-- 维修视频弹窗 -->
    <van-popup v-model="show" @close="close">
      <video 
        class="topvideo" 
        :src="videoUrl" 
        muted 
        loop 
        controls
        webkit-playsinline='true' 
        playsinline='true'
        width="100%"
        ref="videoview"
      >
        <!-- <source src="../../assets/icon/home/预约品鉴.mp4" type="video/mp4" /> -->
      </video>
    </van-popup>
    <base-footers></base-footers>
  </div>
</template>
<script>
import { maintainListApi, maintainSlectApi } from "@/api/api";
import SecondTitle from '@/components/SecondTitle';
import Footers from "@/components/Footers.vue";
import { Icon, Popup, Toast, DropdownMenu, DropdownItem,Empty  } from 'vant';
export default {
  components:{
    SecondTitle,
    [Icon.name]: Icon,
    [Popup.name]:Popup,
    BaseFooters:Footers,
    [DropdownMenu.name]:DropdownMenu,
    [DropdownItem.name]:DropdownItem,
    [Empty.name]:Empty
  },
  data(){
    return{
      show:false,
      page:1,
      page_size:10,
      moreLoading:false,
      noMore:false,
      videoUrl:'',
      file_url:'',
      imgLIst:[],
      seriesVal:'2', //系列下拉默认值
      seriesList:[], //系列下拉列表
      MCTypeVal:'3', //车型下拉默认值
      MCTypeList:[], //车型下拉列表
      manualsVal:'0', //维修视频默认值
      manualsList:[{text:'用户手册下载',value:'0'}], //用户手册下拉列表
      noData:[{text:'暂无数据',value:'-1'}] //无数据下拉显示
    }
  },
  created(){
    
    this.maintainSlectApi()
  },
  methods:{
    // 条件选择列表数据
    maintainSlectApi(){
      const params = {
        m:'Mobile',
        c:'MajorProduct',
        a:'production_class_list',
        lang:1
      }
      maintainSlectApi(params).then(({data})=>{
        data.datas.info.forEach((item,idx) => {
          item.text = item.class_name
          item.value = item.class_id
          item.class_list.forEach((item1,idx1) => {
            item1.text = item1.pro_name
            item1.value = item1.lead_product_id
          });
        });
        this.seriesList = data.datas.info
        this.seriesVal = data.datas.info[0].class_id
        this.MCTypeList = data.datas.info[0].class_list
        this.MCTypeVal = data.datas.info[0].class_list[0].lead_product_id
        this.maintainListApi()
      })
    },
    // 列表数据
    maintainListApi(){
      const params = {
        m:'Mobile',
        c:'Article',
        a:'get_all_news_list',
        lang:1,
        type:9,
        class_id:this.seriesVal,
        id:this.MCTypeVal,
        page:this.page,
        page_size:this.page_size
      }
      maintainListApi(params).then(({data})=>{
        this.moreLoading = false
        if (data.datas.info.length>0) {
          this.file_url = data.datas.info[0].file_url
        }
        if (this.page == 1) {
          this.imgLIst = data.datas.info
          if (this.page*this.page_size > data.datas.count) {
              this.noMore = false
          }
        }else{
          data.datas.info.forEach((item,idx) => {
            if (this.page*this.page_size <= data.datas.count) {
              this.imgLIst.push(item)
            }
            if (this.page*this.page_size > data.datas.count) {
              this.imgLIst.push(item)
              this.noMore = false
            }
          });
        }
      })
    },
    showVideo(val){
      this.show = true
      this.videoUrl = val.video_path
    },
    // 关闭视频弹窗
    close(){
      this.$refs.videoview.pause()
    },
    // 切换系列，更换车型
    seriesConfirm(value){
      const params = {
        m:'Mobile',
        c:'MajorProduct',
        a:'production_class_list',
        lang:1
      }
      maintainSlectApi(params).then(({data})=>{
        data.datas.info.forEach((item,idx) => {
          item.text = item.class_name
          item.value = item.class_id
          item.class_list.forEach((item1,idx1) => {
            item1.text = item1.pro_name
            item1.value = item1.lead_product_id
          });
          if (item.value == value && item.class_list.length>0) {
            this.MCTypeList = item.class_list
            this.MCTypeVal = item.class_list[0].lead_product_id
          }
          if(item.value == value && item.class_list.length==0){
            this.MCTypeList = this.noData
            this.MCTypeVal = this.noData[0].value
          }
        });
      })
    },
    MCTypeConfirm(value){
      this.MCTypeVal = value
      this.maintainListApi()
    },
    manualsConfirm(){
      if (this.file_url) {
        window.open(this.file_url)
      }else{
        Toast('暂无下载数据')
      }
    },
    // 查看更多
    moreClick(){
      this.page++
      this.maintainListApi()
      this.moreLoading = true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>